import { useCallback, useState } from 'react';

const useDisableQuery = () => {
  const [disableQuery, setDisableQuery] = useState(true);

  
  const releaseDisableQuery = useCallback(() => {
      setTimeout(()=>setDisableQuery(false), 500);
  });

  return [
   disableQuery,
    releaseDisableQuery
  ];
};

export default useDisableQuery;
